import { configureStore, type StoreEnhancer } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { createInjectorsEnhancer } from "redux-injectors";
import createReducer from "./reducers";
import loginSaga from "./containers/Login/saga";
import { sessionRestored } from "./containers/Login/slice";
import type { UserRole } from "./containers/Login/types";
import { getAuthRole, getAuthToken, getAuthUser } from "../utils/auth";

export default function configureAppStore() {
  const sagaMiddleware = createSagaMiddleware();
  const { run: runSaga } = sagaMiddleware;

  const injectorsEnhancer = createInjectorsEnhancer({
    createReducer,
    runSaga,
  }) as unknown as StoreEnhancer;

  const store = configureStore({
    reducer: createReducer(),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
    enhancers: (getDefaultEnhancers) =>
      getDefaultEnhancers().concat(injectorsEnhancer),
  });

  sagaMiddleware.run(loginSaga);

  const token = getAuthToken();
  const user = getAuthUser();
  if (token && user) {
    const role = getAuthRole() as UserRole | null;
    store.dispatch(
      sessionRestored({
        id: user.id,
        email: user.email,
        full_name: user.full_name,
        role: role ?? undefined,
        token,
      }),
    );
  }

  return store;
}

export type AppStore = ReturnType<typeof configureAppStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
